import { useBugsnagAdmin } from 'hooks/analytics/bugsnag/useBugsnagAdmin'
import { useBugsnagInit } from 'hooks/analytics/bugsnag/useBugsnagInit'

export const Bugsnag = () => {
  useBugsnagInit()
  useBugsnagAdmin()
  return null
}
